// Actual data sourced from bardofilms.in and vimeo.com/jayantkrishnarohatgi

export const siteConfig = {
  name: "Jayant Rohatgi",
  director: "Jayant Krishna Rohatgi",
  email: "hello@bardofilms.in",
  vimeo: "https://vimeo.com/jayantkrishnarohatgi",
  imdb: "https://www.imdb.com/name/nm14328950/",
  youtube: "https://www.youtube.com/playlist?list=PL6E6A8FFBA500DC2B",
  letterboxd: "https://letterboxd.com/film/sumo-didi/",
  manifesto: "Every silence carries a story. I stay long enough to hear it.",
  thematicStatement: "I’ve learned that people rarely remember what is said; they remember how a moment made them feel. I look for the natural, the almost accidental. A glance that lingers. A pause that wasn’t in the script. A choice a character makes that costs them something. That is where a protagonist’s truth and a story's credibility quietly reveal themselves.",
};

// Hero image from jayantrohatgi.in
export const heroImage = "https://static.wixstatic.com/media/6ba53d_9924fba98295422d978adc47441e9e38~mv2.jpg/v1/fill/w_1920,h_1080,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/6ba53d_9924fba98295422d978adc47441e9e38~mv2.jpg";

// Feature film — kept separate for prominence
export const featureFilm = {
  id: "sumo-didi",
  title: "Sumo Didi",
  year: 2026,
  category: "Feature Film",
  duration: "Full Length",
  thumbnail: "/sumo-didi-thumbnail.jpg",
  hero: "https://customer-assets.emergentagent.com/job_bardo-films-1/artifacts/glbg13xp_Sumo%20DIDI%20TIFF%20Lanscape%20Poster.jpg",
  logline: "A middle class girl from a conservative marwari household defies all odds to turn her perceived weakness into strength and breaks the glass ceiling — inspired by the life of India's first and only female sumo wrestler Hetal Dave.",
  directorsNote: "Sumo Didi is a fiercely inspiring underdog story of Hetal Dave. What drew me to this story was her resilience in challenging everything from patriarchy, societal pressures, gender bias to body politics in a relentless pursuit of a dream that didn’t even exist in her country. Shot in the narrow lanes of Kolkata and the serene Japanese countryside, Sumo Didi is a tale of grit and rising from the depths of despair. At it’s core, this is not just a film about a woman becoming an accomplished Sumo Wrestler, but about a woman willing to give everything to reclaim her space, her body and her power. It is emotional, cinematic, grounded and uplifting.",
  embed: "",
  stills: [
    "https://static.wixstatic.com/media/6ba53d_70cd4688cbbf4bd488f1cffeed5c0775~mv2.jpg/v1/fill/w_1200,h_600,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Sumo%20Didi%20Mood%201.jpg",
    "/sumo-didi-still.jpg",
    "https://customer-assets.emergentagent.com/job_bardo-films-1/artifacts/7mbu90fx_Sumo%20Didi%20TIFF%20poster.JPG",
    "https://customer-assets.emergentagent.com/job_bardo-films-1/artifacts/tv7k34tk_SUMO%20DIDI%20NYIFF.JPG",
    "https://customer-assets.emergentagent.com/job_bardo-films-1/artifacts/g9g1n5s5_SUMO%20DIDI%20PALM%20SPRINGS.JPG",
  ],
  credits: {
    director: "Jayant Krishna Rohatgi",
    production: "Jio Studios, Freshlime Films & MA+TH Entertainment",
    producers: "Jyoti Deshpande, Aakash Chawla, Arunava Sengupta, Amit Chandrra",
    screenwriter: "Nikhil Sachan",
    cinematography: "Akash Agrawal",
    editor: "Devrao Jhadhav",
    score: "Amar Mangrulkar",
    cast: "Shriyam Bhagnani, Chaitnya Sharma, Anubha Fatehpuria, Nitesh Pandey, Raghav Dhir, Meenal Kapoor, Sucheeta Trivedi, Kazumasa Satou",
  },
  festivals: [
    { name: "Tokyo International Film Festival", note: "Nominee — Best Film & Director (Asia Future)" },
    { name: "Palm Springs International Film Festival", note: "Voted into the Best of Fest" },
    { name: "New York Indian Film Festival", note: "Nominee — Best Debut Film & Best Screenplay" },
  ],
  externalLink: "https://variety.com/2023/film/asia/tokyo-indian-female-sumo-wrestler-film-1235767745/",
};

// Commercials — exact Vimeo order (most recent first)
export const films = [
  {
    id: "most-memorable-brand-films",
    title: "Most Memorable Brand Films",
    year: 2024,
    category: "Showreel",
    thumbnail: "https://i.vimeocdn.com/video/1970139144-a77ec6020df5819a02992b1b4965cdb9e724eea64c139054ea027ae5ecaa488f-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/1970139144-a77ec6020df5819a02992b1b4965cdb9e724eea64c139054ea027ae5ecaa488f-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/1046281041",
  },
  {
    id: "foxtale-be-unstoppable",
    title: "Foxtale 'Be Unstoppable'",
    year: 2024,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/1923208891-11d92607f402e7fe8a7ccc87382415bb38367cddf586f85bbb7c66b8bb5c551a-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/1923208891-11d92607f402e7fe8a7ccc87382415bb38367cddf586f85bbb7c66b8bb5c551a-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/1006490849",
  },
  {
    id: "innoviti-excuses",
    title: "Innoviti 'Excuses'",
    year: 2022,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/2070169302-52d594c0867ebc1087e43f67ac4f5b5e493bfec3936541253203c53b42afd59b-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/2070169302-52d594c0867ebc1087e43f67ac4f5b5e493bfec3936541253203c53b42afd59b-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/790847671",
  },
  {
    id: "kinley",
    title: "Kinley",
    year: 2021,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/1369740804-e57507e0ffd76af7e8e7bf289317b1ad0ebe5547e4ad2fd4c6cf8af099c891f0-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/1369740804-e57507e0ffd76af7e8e7bf289317b1ad0ebe5547e4ad2fd4c6cf8af099c891f0-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/675932484",
  },
  {
    id: "amrutanjan-doggys-day-out",
    title: "Amrutanjan 'Doggy's Day Out'",
    year: 2021,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/1278479795-9d76e700353c24c531af6cdebe1b04a9c3ad192edb132a561_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/1278479795-9d76e700353c24c531af6cdebe1b04a9c3ad192edb132a561_1280x720?region=us",
    embed: "https://player.vimeo.com/video/636086222",
  },
  {
    id: "jeevansathi-umpire",
    title: "Jeevansathi 'Umpire'",
    year: 2021,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/1123451533-b2c7ae349718803cdd4595afbbdf34bde66ece4ccda44a86fdcd9b4fdca55a1e-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/1123451533-b2c7ae349718803cdd4595afbbdf34bde66ece4ccda44a86fdcd9b4fdca55a1e-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/542683872",
  },
  {
    id: "jeevansathi-locker-room",
    title: "Jeevansathi 'Locker Room'",
    year: 2021,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/1134513228-24b9172e9cba25ed2a15c738505483d32fe90b87bd5b9b3d004841d7c280ae86-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/1134513228-24b9172e9cba25ed2a15c738505483d32fe90b87bd5b9b3d004841d7c280ae86-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/547372514",
  },
  {
    id: "layerr-wottagirl-perfume",
    title: "Layer'r Wottagirl Perfume",
    year: 2019,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/803420429-8472b421a4b864910143da293a0f2e117f38449c17c1d638a52c539d46907382-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/803420429-8472b421a4b864910143da293a0f2e117f38449c17c1d638a52c539d46907382-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/351737288",
  },
  {
    id: "amrutanjan-double-power",
    title: "Amrutanjan Double Power",
    year: 2024,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/1973087921-ee262821c630f0cbabe9d7c8bfdf7e006741b251761c93e4af7ee92ef2d11b55-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/1973087921-ee262821c630f0cbabe9d7c8bfdf7e006741b251761c93e4af7ee92ef2d11b55-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/1048862424",
  },
  {
    id: "layerr-wottagirl-cafe",
    title: "Layer'r Wottagirl 'Cafe'",
    year: 2019,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/852184789-188c4d6b2431ed3202a6008930facae25ffab945ee595fa6b7e04341e5afcb79-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/852184789-188c4d6b2431ed3202a6008930facae25ffab945ee595fa6b7e04341e5afcb79-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/388778562",
  },
  {
    id: "juicy-fruit",
    title: "Juicy Fruit",
    year: 2019,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/791993283-35f8392ce2f5d5c694e782381dc275574442ce44b36419e615bed74ead38a763-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/791993283-35f8392ce2f5d5c694e782381dc275574442ce44b36419e615bed74ead38a763-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/342709753",
  },
  {
    id: "real-activ",
    title: "Real Activ",
    year: 2016,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/635087049-a4d558c5fd2f8591d1bc1c4812db18f087e4288b2071a28da299d3762d18d418-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/635087049-a4d558c5fd2f8591d1bc1c4812db18f087e4288b2071a28da299d3762d18d418-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/217783762",
  },
  {
    id: "dominos-2",
    title: "Domino's 2.0",
    year: 2017,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/677049118-1c9516edfeda174b028b2384c2660236ec1d0190105d5857cf1cba464516f218-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/677049118-1c9516edfeda174b028b2384c2660236ec1d0190105d5857cf1cba464516f218-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/250849270",
  },
  {
    id: "cleartrip-local",
    title: "Cleartrip Local",
    year: 2016,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/1969580003-74049482b6bfbc5daac611a648974f60b68da7b76b10fd9bfc6312de8692ab83-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/1969580003-74049482b6bfbc5daac611a648974f60b68da7b76b10fd9bfc6312de8692ab83-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/174019709",
  },
  {
    id: "colormate-salon",
    title: "Colormate 'Salon'",
    year: 2017,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/689571392-69f1470fe1bd0055ba8e6ec4aa5f919a1f7468975f242e8f31639029380cbf3a-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/689571392-69f1470fe1bd0055ba8e6ec4aa5f919a1f7468975f242e8f31639029380cbf3a-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/260756870",
  },
  {
    id: "nilkamal-furniture-beats",
    title: "Nilkamal Furniture 'Beats'",
    year: 2016,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/597445183-db858dca1c76c6f1c4b51d0e0b24e5ad8d0c871e9ea6d95a39e6997254d086d3-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/597445183-db858dca1c76c6f1c4b51d0e0b24e5ad8d0c871e9ea6d95a39e6997254d086d3-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/187035338",
  },
  {
    id: "nilkamal-mattress-the-fight",
    title: "Nilkamal Mattress 'The Fight'",
    year: 2016,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/597447184-fbd5b749743ff4800b895d662457573efd0c26510491ea4e5390cc688eecd28e-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/597447184-fbd5b749743ff4800b895d662457573efd0c26510491ea4e5390cc688eecd28e-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/187648550",
  },
  {
    id: "nilkamal-mattress-the-nag",
    title: "Nilkamal Mattress 'The Nag'",
    year: 2016,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/597446430-3c1a58cca04117d20c504d889bc5fdcef7d21422179af2eef8999bd0528bcece-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/597446430-3c1a58cca04117d20c504d889bc5fdcef7d21422179af2eef8999bd0528bcece-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/187647124",
  },
  {
    id: "glucovita-bolts",
    title: "Glucovita Bolts",
    year: 2015,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/552461136-487a8ff2e50527a4dd609e96f93eb1cf1b0b44dbf7d3aac7eba0ad5f54dcf99b-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/552461136-487a8ff2e50527a4dd609e96f93eb1cf1b0b44dbf7d3aac7eba0ad5f54dcf99b-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/152458950",
  },
  {
    id: "maaza-blackout",
    title: "Maaza 'Blackout'",
    year: 2014,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/501753321-a16a8fe3dff0f7e102da66c8bf120baf4301eaeb1753900ed4319a8e5ce3e22e-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/501753321-a16a8fe3dff0f7e102da66c8bf120baf4301eaeb1753900ed4319a8e5ce3e22e-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/115473039",
  },
  {
    id: "carwale-unnis-bees",
    title: "Carwale 'Unnis Bees'",
    year: 2015,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/535298379-563d1c258f8a0c88f1008e5319c7ba51de12ee254daafcd90ef1064cf509fe53-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/535298379-563d1c258f8a0c88f1008e5319c7ba51de12ee254daafcd90ef1064cf509fe53-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/138602395",
  },
  {
    id: "maaza-jango",
    title: "Maaza Jango",
    year: 2015,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/514804933-b498fdf2563a4850eb06bb87deaad6768053945f8bee06b1f538dcea3382e2e3-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/514804933-b498fdf2563a4850eb06bb87deaad6768053945f8bee06b1f538dcea3382e2e3-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/124905225",
  },
  {
    id: "dominos-aha-value",
    title: "Domino's AHA Value",
    year: 2015,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/513808399-9957e0cbc8d23ec08c00d0c4e7623d94cd440f94a868dcfabd6e039aa05f178c-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/513808399-9957e0cbc8d23ec08c00d0c4e7623d94cd440f94a868dcfabd6e039aa05f178c-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/124184638",
  },
  {
    id: "maaza-time-machine",
    title: "Maaza Time Machine",
    year: 2014,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/1969580177-3403c8d20ab6d782fb2e09a0f8c7a658e5db602c8c06e05d76906c6f76e3b183-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/1969580177-3403c8d20ab6d782fb2e09a0f8c7a658e5db602c8c06e05d76906c6f76e3b183-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/97720127",
  },
  {
    id: "lite-horlicks",
    title: "Lite Horlicks",
    year: 2017,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/677256646-eb981623a467a4f84139250f5b04f02f7e1a7f288672daf0d56243bb2d2cfb5e-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/677256646-eb981623a467a4f84139250f5b04f02f7e1a7f288672daf0d56243bb2d2cfb5e-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/251017613",
  },
  {
    id: "wechat-the-proposal",
    title: "WeChat — The Proposal",
    year: 2013,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/455462868-41159fcbed37374395938d190e2405e2b92920a244f417247862f43f5420d8f9-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/455462868-41159fcbed37374395938d190e2405e2b92920a244f417247862f43f5420d8f9-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/79704119",
  },
  {
    id: "askme-gabbar",
    title: "AskMe — Gabbar",
    year: 2014,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/482433458-a1d5a3df464da7f7fbc16cdb8bcb58ce7463e753fafdbf1cbf2ed23e3c7fca88-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/482433458-a1d5a3df464da7f7fbc16cdb8bcb58ce7463e753fafdbf1cbf2ed23e3c7fca88-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/100426070",
  },
  {
    id: "askme-tareekh",
    title: "AskMe 'Tareekh'",
    year: 2014,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/482433771-65609810892ffffb958db730abeed7af7a6cc4165cab08cef93f4b3ebaee9fba-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/482433771-65609810892ffffb958db730abeed7af7a6cc4165cab08cef93f4b3ebaee9fba-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/100418508",
  },
  {
    id: "wechat-green-room",
    title: "WeChat — Green Room",
    year: 2013,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/453072612-bd0dad17ef8e3c612baa60dc643710940d2db99ada228240e6577633e0b3c676-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/453072612-bd0dad17ef8e3c612baa60dc643710940d2db99ada228240e6577633e0b3c676-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/77772672",
  },
  {
    id: "wechat-morning",
    title: "WeChat — Morning",
    year: 2013,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/451936916-a06a041dd74b0df6e34144d5ce823c46f44732454fc4924e141b1a66592a38eb-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/451936916-a06a041dd74b0df6e34144d5ce823c46f44732454fc4924e141b1a66592a38eb-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/76751598",
  },
  {
    id: "maaza-sachurrday",
    title: "Maaza Sachurrday",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/442856223-8179a46888c650c831719008e152c3b37ff6d59bd413ae025fd06df7c5738b4b-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/442856223-8179a46888c650c831719008e152c3b37ff6d59bd413ae025fd06df7c5738b4b-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/62165767",
  },
  {
    id: "maaza-switty",
    title: "Maaza Switty",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/442856317-54a7cafb6498ddbfac8814828b9a879b40a31ad30a4a40aaadf6803ec4f77b3c-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/442856317-54a7cafb6498ddbfac8814828b9a879b40a31ad30a4a40aaadf6803ec4f77b3c-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/60234756",
  },
  {
    id: "askme-brand-film",
    title: "Ask Me — Brand Film",
    year: 2014,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/502190209-c966c642590efca5452851ba718cb3e29b8c4b7aa951f76bf00e14d0fd27c9fa-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/502190209-c966c642590efca5452851ba718cb3e29b8c4b7aa951f76bf00e14d0fd27c9fa-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/100504867",
  },
  {
    id: "voltas-murthy",
    title: "Voltas Murthy",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/648256491-1fb93dbaa554179ef009e3699515683e39a68eaaac8605116a48e34e79e97b4f-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/648256491-1fb93dbaa554179ef009e3699515683e39a68eaaac8605116a48e34e79e97b4f-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/60225182",
  },
  {
    id: "maaza-asur",
    title: "Maaza Asur",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/2070167614-c4f42d71e26749de10b9201b56855ca6d3fb3f006a1bcf53498fb06fe26c1e57-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/2070167614-c4f42d71e26749de10b9201b56855ca6d3fb3f006a1bcf53498fb06fe26c1e57-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/60165269",
  },
  {
    id: "dominos-cheesy-happy-feeling",
    title: "Domino's Cheesy Happy Feeling",
    year: 2014,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/501095981-cbfc46c8428234a2e03a158c05ec73f4d0a34ea520d7cc5132e332c9317e2c9a-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/501095981-cbfc46c8428234a2e03a158c05ec73f4d0a34ea520d7cc5132e332c9317e2c9a-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/115163226",
  },
  {
    id: "askme-deewar",
    title: "AskMe 'Deewar'",
    year: 2014,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/482433256-323cb0c7faf55e588cb349a2c74cea393679735b0b1d88773694ec1b5abb33fa-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/482433256-323cb0c7faf55e588cb349a2c74cea393679735b0b1d88773694ec1b5abb33fa-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/100485176",
  },
  {
    id: "askme-kuttey",
    title: "AskMe 'Kuttey'",
    year: 2014,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/648258369-c6310c54612d37929cfb557f43e5256c0befdc03acab542216b2ba6cd49db9fd-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/648258369-c6310c54612d37929cfb557f43e5256c0befdc03acab542216b2ba6cd49db9fd-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/100426555",
  },
  {
    id: "polycrol",
    title: "Polycrol",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/418642923-94b12174d766421feecc9018cc7cdef98db81d435f8bf2ee334da1510158d0d8-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/418642923-94b12174d766421feecc9018cc7cdef98db81d435f8bf2ee334da1510158d0d8-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/60165101",
  },
  {
    id: "policybazaar-car",
    title: "PolicyBazaar — Car",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/418649504-b1c0a64bcdd9a899169a14a261c3d177ddbe1e420d7ee0621e16f0316c161055-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/418649504-b1c0a64bcdd9a899169a14a261c3d177ddbe1e420d7ee0621e16f0316c161055-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/60165464",
  },
  {
    id: "maaza-lost-cow",
    title: "Maaza Lost Cow",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/418643446-1b3a368861bffc0372ed5f49f1aa407e5b32febd3ffbd175ad2cb88a1ec9780f-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/418643446-1b3a368861bffc0372ed5f49f1aa407e5b32febd3ffbd175ad2cb88a1ec9780f-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/60164962",
  },
  {
    id: "icici-hero-father",
    title: "ICICI Hero — Father",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/401201289-8c8547b9d37b551963931d7168e365bb42c28a5c1bc9f0d6721b6178f7fbc63f-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/401201289-8c8547b9d37b551963931d7168e365bb42c28a5c1bc9f0d6721b6178f7fbc63f-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/57849761",
  },
  {
    id: "castrol",
    title: "Castrol",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/482431797-82a191713f8c38f5d950bc51c152902a7c6597dc47978b604b98c9ceb1cfd7b0-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/482431797-82a191713f8c38f5d950bc51c152902a7c6597dc47978b604b98c9ceb1cfd7b0-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/60082300",
  },
  {
    id: "teacity",
    title: "Teacity",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/2070169078-dc97fac19ec3ba526b2f81fc8dfb1de7fe54ceb1eee79403abf5982e178bdb06-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/2070169078-dc97fac19ec3ba526b2f81fc8dfb1de7fe54ceb1eee79403abf5982e178bdb06-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/60148540",
  },
  {
    id: "bausch-lomb",
    title: "Bausch & Lomb",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/2070168063-2221ebad492b798bb478992157815e5f99bd6724abe44f7b8ec304e9acfcd773-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/2070168063-2221ebad492b798bb478992157815e5f99bd6724abe44f7b8ec304e9acfcd773-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/60148471",
  },
  {
    id: "red-label",
    title: "Red Label",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/482432887-681569ec9a36163501edc0c61568689581f33987c25fd7ff1272d338956f744a-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/482432887-681569ec9a36163501edc0c61568689581f33987c25fd7ff1272d338956f744a-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/57849762",
  },
  {
    id: "policybazaar-movie",
    title: "Policybazaar — Movie",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/451937218-e765fd0479a6d16b21d2c510267fe7b38fae2907b8b5c1dd247d59d20baebbc9-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/451937218-e765fd0479a6d16b21d2c510267fe7b38fae2907b8b5c1dd247d59d20baebbc9-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/67549796",
  },
  {
    id: "yebhi",
    title: "Yebhi.com",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/418538762-f04cfa072ad9cdf8742b4ad70ef9c2cd0a683421d1c444151306a196b7d9da84-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/418538762-f04cfa072ad9cdf8742b4ad70ef9c2cd0a683421d1c444151306a196b7d9da84-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/60149570",
  },
  {
    id: "colgate-plax",
    title: "Colgate Plax",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/418526646-11ba738938228964c36e4d2791cedb70476f39021a9f17e316e4a565465fc237-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/418526646-11ba738938228964c36e4d2791cedb70476f39021a9f17e316e4a565465fc237-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/60148558",
  },
  {
    id: "clinic-plus",
    title: "Clinic Plus",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/482432213-2f2a16d52a01fd0ce873d38f1d1d380181275b56057ab042924c905c8ccc55bf-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/482432213-2f2a16d52a01fd0ce873d38f1d1d380181275b56057ab042924c905c8ccc55bf-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/57997980",
  },
  {
    id: "first-choice",
    title: "First Choice",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/401205277-7c0d62762c69ccc0f80741bc1f5f0f72b2b779874a29a5f719a5d9e831e579fc-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/401205277-7c0d62762c69ccc0f80741bc1f5f0f72b2b779874a29a5f719a5d9e831e579fc-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/57850367",
  },
  {
    id: "samsung-guru",
    title: "Samsung Guru",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/402305592-7e7e3a76b34739fbbe7e0526d514fb8d33a022168be29ecbb5d0da0b5c4cae93-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/402305592-7e7e3a76b34739fbbe7e0526d514fb8d33a022168be29ecbb5d0da0b5c4cae93-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/57997978",
  },
  {
    id: "icici-pru-retirement",
    title: "ICICI Pru Retirement",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/482430488-66e32e85cf425f5144ffa846e65df49a495a2061783ad703a95cc70e6ba7352d-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/482430488-66e32e85cf425f5144ffa846e65df49a495a2061783ad703a95cc70e6ba7352d-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/72715754",
  },
  {
    id: "pepsi",
    title: "Pepsi",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/482430757-80efe3d598792f94078a84bbadfb07c496b44df90d498c275bcce8d5282b4a1c-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/482430757-80efe3d598792f94078a84bbadfb07c496b44df90d498c275bcce8d5282b4a1c-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/69559924",
  },
  {
    id: "vim-ad-break",
    title: "Vim Ad Break",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/442496282-bed16c20e5a7c72c7918eddf8390698c16b6892b853c7191e623e1af98aff5bc-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/442496282-bed16c20e5a7c72c7918eddf8390698c16b6892b853c7191e623e1af98aff5bc-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/69637000",
  },
  {
    id: "elvis",
    title: "Elvis",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/442378576-d0b1fbbc40e29296c708ddffe1040aa7d7483be9fcd3c533e56fdefc954ba93b-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/442378576-d0b1fbbc40e29296c708ddffe1040aa7d7483be9fcd3c533e56fdefc954ba93b-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/69557386",
  },
  {
    id: "the-slim-film",
    title: "The Slim Film",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/401201189-78b49f7ccd25856709cf8492f40535f938ac8949f050b83c6a2186818dc9cfe6-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/401201189-78b49f7ccd25856709cf8492f40535f938ac8949f050b83c6a2186818dc9cfe6-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/57849759",
  },
  {
    id: "taaza-tea",
    title: "Taaza Tea",
    year: 2015,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/513809479-16b0c44f1f5a6d28e29277a1e80cb6dceb181f398d5f71cbbccd9293c08729a2-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/513809479-16b0c44f1f5a6d28e29277a1e80cb6dceb181f398d5f71cbbccd9293c08729a2-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/124185785",
  },
   {
    id: "vim-neem-gel",
    title: "Vim Neem Gel",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/442855261-a8eda5ca4b75022befb42d4b54916ebd90a8839f602a8702bf31b120db590b40-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/442855261-a8eda5ca4b75022befb42d4b54916ebd90a8839f602a8702bf31b120db590b40-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/69075906",
  },
  {
    id: "icici-hero-daughter",
    title: "ICICI Hero — Daughter",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/446629846-ff4b5db611d32a68ab203b30c72d787a9f551eaa43a98402423c86a9dc9d7857-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/446629846-ff4b5db611d32a68ab203b30c72d787a9f551eaa43a98402423c86a9dc9d7857-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/72716025",
  },
  {
    id: "britannia-treat",
    title: "Britannia Treat",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/482430369-fb673167637b5ec69112bcc03ed0cccb42beb61bd1d02a463bada403d58312c3-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/482430369-fb673167637b5ec69112bcc03ed0cccb42beb61bd1d02a463bada403d58312c3-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/69637717",
  },
  {
    id: "vim-announcer",
    title: "Vim Announcer",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/482430579-a570ad76e559c1063ddff3d7dc84f95fb255a449050f89bbce4fd334d61db9b1-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/482430579-a570ad76e559c1063ddff3d7dc84f95fb255a449050f89bbce4fd334d61db9b1-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/69637210",
  },
  {
    id: "icici-click-click",
    title: "ICICI — Click Click",
    year: 2013,
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/446630645-9c112c97a57d21e6225ba30f754170b0e4bd7002484bf297935fd69dd9e2edce-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/446630645-9c112c97a57d21e6225ba30f754170b0e4bd7002484bf297935fd69dd9e2edce-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/72716728",
  },
 
  {
    id: "horlicks-nutribar",
    title: "Horlicks Nutribar",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/442352078-29e041f5e951e4f9114b7bb2f94f49adda4895adfbaada2644037dcf5b2c61ce-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/442352078-29e041f5e951e4f9114b7bb2f94f49adda4895adfbaada2644037dcf5b2c61ce-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/69539866",
  },
  {
    id: "sunfeast-pasta-treat",
    title: "Sunfeast Pasta Treat",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/482431239-6c7731ddb79126deec05df8677863e10aba1e509a747796f30eb67187af807cd-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/482431239-6c7731ddb79126deec05df8677863e10aba1e509a747796f30eb67187af807cd-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/69532703",
  },
  {
    id: "cif",
    title: "CIF",
    category: "Brand Film",
    thumbnail: "https://i.vimeocdn.com/video/442339461-5f8331340ec7ae6a8e622969539051a4f75c7ae15b4fc61285a726fa69a1a7a1-d_640x360?region=us",
    hero: "https://i.vimeocdn.com/video/442339461-5f8331340ec7ae6a8e622969539051a4f75c7ae15b4fc61285a726fa69a1a7a1-d_1280x720?region=us",
    embed: "https://player.vimeo.com/video/69530967",
  },
];
// Combine feature film + commercials for unified access
export const allWork = [featureFilm, ...films];

// Advertising showreel links from bardofilms.in
export const showreels = [
  { label: "Showcase", url: "https://vimeo.com/showcase/8645797" },
  { label: "Extensive", url: "https://vimeo.com/showcase/8645811" },
  { label: "Humour", url: "https://vimeo.com/showcase/8635949" },
  { label: "FMCG", url: "https://vimeo.com/showcase/6736783" },
  { label: "Celebrity", url: "https://vimeo.com/album/5266683" },
  { label: "F & B", url: "https://vimeo.com/showcase/11461082" },
];

export const aboutData = {
  portrait: "https://static.wixstatic.com/media/6ba53d_0fd4f5a19d324c15a92c8705a168353e~mv2.jpeg/v1/fill/w_600,h_700,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/053124_NYIFF_Day%201_Red%20Carpet_BY%20_Carlos%20Sanfer-67.jpeg",
  bio: "Born in the idyllic lanes of 1980s North Kolkata, my early years were spent chasing kites before eventually chasing degrees in business and commerce. Recognising that my  calling lay elsewhere, I left it for theatre, where my love for storytelling sparked. After graduating, I moved to Mumbai to break into advertising filmmaking and eventually began directing television commercials. Over time, my craft has distilled into a singular voice - one that dwells in the quiet intersections of human emotion, the sudden weight of drama and the saving grace of everyday humour.",
  sections: [
    {
      heading: "The Unscripted Truth",
      text: "I’ve learned that people rarely remember what is said; they remember how a moment made them feel. I look for the natural, the almost accidental. A glance that lingers. A pause that wasn’t in the script. A choice a character makes that costs them something. That is where a protagonist’s truth and a story's credibility quietly reveal themselves.",
    },
    {
      heading: "Earning the Moment",
      text: "Every silence carries a story, I stay long enough to hear it.  I'm drawn to stories of human dispositions which are emotive, reflective and the ones that find the funny side of life. Directing is about decisive empathy. In both narrative and advertising filmmaking, my approach is rooted in character driven truth, in patience and observation, in capturing the unspoken, overlooked moments that hold the most weight. When a moment feels honest, the brand doesn't have to announce itself, it earns its place within the story.",
    },
    {
      heading: "Visual Language",
      text: "I trust subtext, allowing the audience to connect the dots. I like restraint and leaving space — in performance, in framing, in storytelling. My frames observe rather than explain and leave room for the viewer to bring their own meaning to the moment.",
    },
    {
      heading: "Selected Recognition",
      text: "Tokyo International Film Festival 2023 – Nominee – Best Film & Director (Asia Future)\n\nPalm Springs International Film Festival 2024 – Voted into Best of Fest\n\nNew York Indian Film Festival 2024 – Nominee – Best Debut Film & Best Screenplay",
    },
  ],
};

export const contactData = {
  closingLine: "If you have a story that needs patience, I'd like to hear it.",
};
